{
  "countryCode": "Country code",
  "choosePlaceholder": "Choose the country",
  "countrySearch": "Search for a country by name or code",
  "noCountry": "No matching country",
  "helper": "Enter a mobile number",
  "errors": {
    "PHONE_REQUIRED": "The phone number is required",
    "PHONE_INVALID": "The phone number is not valid",
    "PHONE_NOT_MOBILE": "Landline numbers are not allowed. Enter a mobile number",
    "PHONE_COUNTRY_NOT_ALLOWED": "Numbers from this country are not accepted"
  }
}
